import Select2Multiple from 'v-select2-multiple-component';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import axios from "axios";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import store from "@/store";
import {
  required
} from "vuelidate/lib/validators";

export default {
  name: "timetableCreate",
  components: {
    MainLayout,
    Select2Multiple,
    Loading,
  },

  data() {
    return {
      submitted: false,
      isLoading: false,
      academicYear: [],
      academicYearArr: null,
      classArr: null,
      subjectCount: [],
      subjectArr: [],
      acd_year_id: '',
      class_id: null,
      days: null,
      time: null,
      dayCount: 0,
      timeCount: 0,
      subjectRows: new Array(7).fill([]).map(() => new Array(10).fill("")),
      teacherRows: new Array(7).fill([]).map(() => new Array(10).fill("")),
      teacherOptionsByCell: {},
      teacherMap: {},
      noClassMsg: '',
      templateArr: null,
      template_id: null,
      rows: [],
    };
  },

  validations() {
    return {
      acd_year_id: { required },
      class_id: { required },
      template_id: { required }
    };
  },

  methods: {
    getCurrentPeriodList() {
      axios.get('/getAcademicYear', {
        params: {
          campus_id: store.state.user.campus_id,
        }
      })
        .then(res => {
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'Select Academic Year'
          }];
          this.academicYearArr = $defaultSelectOption.concat(res.data.academicYearArr);
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    getClass($yearId) {
      axios.get("class/classList/" + $yearId, {
        params: {
          campus_id: store.state.user.campus_id,
        }
      })
        .then(res => {
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'Select Class'
          }];
          this.classArr = $defaultSelectOption.concat(res.data);
          if (this.classArr.length > 1) {
            this.noClassMsg = '';
          } else {
            this.noClassMsg = 'There is no class to show.';
          }
          this.isLoading = false;
        }).catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    changeEvent(val) {
      this.subjectRows = new Array(7).fill([]).map(() => new Array(10).fill(""));
      this.teacherRows = new Array(7).fill([]).map(() => new Array(10).fill(""));
      this.teacherOptionsByCell = {};
      this.teacherMap = {};
      this.isLoading = true;
      this.getTimetableMeta(val);
      this.subjectArr = [];
      this.getSubjectByClassId(val);
    },

    changeAcademicYearEvent(acdYearId) {
      this.class_id = null;
      this.template_id = null;
      this.templateArr = null;
      this.timeCount = 0;
      this.getClass(acdYearId);
    },

    getSubjectByClassId($classId) {
      axios.get("/class/subjectByClassId/" + $classId, {
        params: {
          acd_year_id: this.acd_year_id,
          campus_id: this.$store.state.user.campus_id
        }
      })
      .then((response) => {
        this.subjectArr = response.data.subjectArr[0];
        this.teacherMap = response.data.teacherMap || {};
        this.isLoading = false;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
      });
    },

    getTimetableMeta($classId) {
      axios.get("/timetableMeta/getDataForTimetable/" + $classId)
      .then((response) => {
        this.days = response.data[0][0];
        this.time = response.data[0][1];
        this.dayCount = this.days.length;
        this.timeCount = this.time.length;
        this.isLoading = false;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
      });
    },

    /**
     * Returns the teacher options for a cell from the cache.
     */
    getTeacherOptions(rowIndex, colIndex) {
      const key = `${rowIndex}_${colIndex}`;
      return this.teacherOptionsByCell[key] || [];
    },

    /**
     * When the subject dropdown changes, look up the teacher options
     * from the cached teacherMap (loaded with subjects) and reset the
     * previously-selected teacher for this cell.
     */
    onSubjectChange(rowIndex, colIndex, selectedSubjectId) {
      const key = `${rowIndex}_${colIndex}`;
      this.$set(this.teacherRows[rowIndex], colIndex, '');
      if (!selectedSubjectId || selectedSubjectId === '0' || selectedSubjectId === 0) {
        this.$set(this.teacherOptionsByCell, key, []);
        return;
      }
      this.$set(this.teacherOptionsByCell, key, this.teacherMap[selectedSubjectId] || []);
    },

    create() {
      this.submitted = true;
      if (this.$v.$invalid || !this.days || !this.time || this.timeCount == 0) {
        return;
      }

      this.isLoading = true;
      const preparedData = [];
      for (let rowIndex = 0; rowIndex < this.days.length; rowIndex++) {
        for (let columnIndex = 0; columnIndex < this.time.length; columnIndex++) {
          const dayId = this.days[rowIndex].id;
          const timeId = this.time[columnIndex].id;
          const subjectId = this.rows[rowIndex][columnIndex];
          const rowData = {
            day_id: dayId,
            time_id: timeId,
          };
          if (subjectId !== undefined && subjectId !== null) {
            rowData.subject_id = subjectId;
          }
          preparedData.push(rowData);
        }
      }

      axios.post("/timetable/create", {
        items: preparedData,
        class_id: this.class_id,
        template_id: this.template_id,
        login_id: this.$store.state.user.id
      })
        .then(response => {
          if (response.data.status == 200) {
            this.$notification.success("Timetable Added Successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({
              name: "timetableList"
            });
          }
        })
        .catch(error => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          } else if (error.response && error.response.status == 422) {
            this.$notification.error(error.response.data.message || "Cannot create timetable", {
              timer: 3,
              position: "bottomCenter"
            });
            this.isLoading = false;
          }
        });
    },

    getTemplates() {
      this.isLoading = true;
      axios.get('/timetableMeta/templates', {
        params: {
          campus_id: store.state.user.campus_id,
        }
      })
        .then(res => {
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'Select Template'
          }];
          const templates = res.data.templates.map(t => ({
            'id': t.id,
            'text': t.name
          }));
          this.templateArr = $defaultSelectOption.concat(templates);
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    changeTemplateEvent(templateId) {
      if (!templateId || templateId == 0) {
        this.timeCount = 0;
        this.dayCount = 0;
        this.days = null;
        this.time = null;
        return;
      }
      this.rows = new Array(7).fill([]).map(() => new Array(10).fill(""));
      this.isLoading = true;
      this.getTimetableMetaByTemplate(templateId);
    },

    getTimetableMetaByTemplate(templateId) {
      this.isLoading = true;
      axios.get("/timetableMeta/getDataForTimetableByTemplate/" + templateId)
        .then((response) => {
          this.days = response.data.data[0];
          this.time = response.data.data[1];
          this.dayCount = this.days.length;
          this.timeCount = this.time.length;
          
          this.selectedSubjects = Array.from({ length: this.dayCount }, () =>
            Array.from({ length: this.timeCount }, () => null)
          );
          
          this.rows = this.selectedSubjects;
          this.isLoading = false;
        })
        .catch((error) => {
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    changeClassEvent(classId) {
      this.class_id = classId;
      this.template_id = null;
      this.templateArr = null;
      this.getTemplates();
      this.getSubjectByClassId(classId);
    },
  },

  mounted() {
    this.getCurrentPeriodList();
  },
};
